import { render, staticRenderFns } from "./Attic.vue?vue&type=template&id=317f11d7&scoped=true&"
import script from "./Attic.vue?vue&type=script&lang=js&"
export * from "./Attic.vue?vue&type=script&lang=js&"
import style0 from "./Attic.vue?vue&type=style&index=0&id=317f11d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f11d7",
  null
  
)

export default component.exports